import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { styled } from 'styled-components'

import { SegmentCard } from '../../Segment/Segment.Styled'

export const StyledWrapper = styled(SegmentCard)`
  display: flex;
  flex-direction: row;
  gap: 12px;
`

export const StyledIconWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors['N Surface/Brand']};

  ${StyledIcon} {
    width: 22px;
    height: 22px;
    color: ${({ theme }) => theme.colors['N General/Brand']};
  }
`

export const StyledHighlight = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
`
